import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useAuth } from './hooks/use-auth';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import SignUp from './pages/account/CreateAdminUser';
import SignIn from './pages/account/SignIn';
import ForgotPassword from 'pages/account/ForgotPassword';

import Calendar from './Calendar';
import Home from './pages/Home';
import Top from './pages/f0/Top';
import Orders from './pages/f0/Orders';
import ProductNumbers from './pages/f0/ProductNumbers';
import Processes from './pages/f0/Processes';
import ProcessesProgress from 'pages/f0/ProcessesProgress';
import Account from './pages/f0/Account';
import Users from 'pages/account/Users';
import User from 'pages/account/User';
import ProcessesRequest from './pages/f0/ProcessesRequest';
import ProcessesRequested from './pages/f0/ProcessesRequested';

import Master from './pages/master/Master';
import MasterEquipments from './pages/master/Equipments';
import MasterCustomers from './pages/master/Customers';
import MasterSuppliers from './pages/master/Suppliers';
import MasterProductNumbers from './pages/master/ProductNumbers';
import MasterProcesses from './pages/master/Processes';
import MasterDefectiveLists from './pages/master/DefectiveLists';
import MasterFactoryBreakings from './pages/master/FactoryBreakings';
import MasterWorkingProcessLists from './pages/master/WorkingProcessLists';
import MasterFactoryClosedDates from './pages/master/FactoryClosedDates';
import MasterStandardProcesses from './pages/master/StandardProcesses';
import MasterStatuses from './pages/master/Statuses';

import F1Equipments from './pages/f1/Equipments';
import F1EquipmentRoute from './pages/f1/EquipmentRoute';
import F1ProductNumbers from './pages/f1/main/ProductNumbers';

import F2Home from './pages/f2/Home';
import F2ShareDrive from './pages/f2/ShareDrive';

import Header from './components/Header';

import F0 from './styled/F0';
import F1 from './styled/F1';
import F2 from './styled/F2';

function SignedIn() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      console.log(isAuthenticated);
      navigate('');
    }
  }, [isAuthenticated, navigate]);

  return (
    <>
      <Header />
      <Outlet />
    </>
  );
}

function App() {
  const auth = useAuth();

  if (auth.isLoading) {
    return <div></div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<SignIn />} />
        <Route path="createadmin" element={<SignUp />} />
        <Route path="forget-password" element={<ForgotPassword />} />
        <Route element={<SignedIn />}>
          <Route path="home" element={<Home />} />
          <Route path="f0" element={<F0 />}>
            <Route index element={<Calendar />} />
            <Route path="orders" element={<Orders />} />
            <Route path="product-numbers" element={<ProductNumbers />} />
            <Route path="processes" element={<Processes />} />
            <Route path="processes-progress" element={<ProcessesProgress />} />
            <Route path="master">
              <Route index element={<Master />} />
              <Route path="equipments" element={<MasterEquipments />} />
              <Route path="customers" element={<MasterCustomers />} />
              <Route path="suppliers" element={<MasterSuppliers />} />
              <Route
                path="product-numbers"
                element={<MasterProductNumbers />}
              />
              <Route path="processes" element={<MasterProcesses />} />
              <Route
                path="defective-lists"
                element={<MasterDefectiveLists />}
              />
              <Route
                path="working-process-lists"
                element={<MasterWorkingProcessLists />}
              />
              <Route
                path="factory-breakings"
                element={<MasterFactoryBreakings />}
              />
              <Route
                path="factory-closed-dates"
                element={<MasterFactoryClosedDates />}
              />
              <Route
                path="standard-processes"
                element={<MasterStandardProcesses />}
              />
            </Route>
            <Route path="processes-request" element={<ProcessesRequest />} />
            <Route
              path="processes-requested"
              element={<ProcessesRequested />}
            />
            <Route path="account" element={<Account />} />
            <Route path="users" element={<Users />} />
            <Route path="user" element={<User />} />
          </Route>
          <Route path="f1" element={<F1 />}>
            <Route index element={<Top />} />
            <Route path="equipments">
              <Route index element={<F1Equipments />} />
              <Route path=":id/*" element={<F1EquipmentRoute />} />
            </Route>
            <Route path="master">
              <Route index element={<Master />} />
              <Route path="equipments" element={<MasterEquipments />} />
              <Route
                path="product-numbers"
                element={<MasterProductNumbers />}
              />
              <Route path="statuses" element={<MasterStatuses />} />
            </Route>
            <Route path="account" element={<Account />} />
            <Route path="users" element={<Users />} />
            <Route path="user" element={<User />} />
          </Route>
          <Route path="f2" element={<F2 />}>
            <Route index element={<F2Home />} />
            <Route path="share-drives" element={<F2ShareDrive />} />
          </Route>
        </Route>
        <Route path="*" element={<p>Page Not Found</p>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
